import React, { useEffect, useState } from 'react';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ValidacionExpatriadosDetalleScreen } from './screen';
import { ValidacionesExpatriadosAdapter } from '../../../../../../infraestructure/persistence/rest/ValidacionesExpatriadosAdapter';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';

interface Props{
    filter:any;
    visible:boolean;
	translate(word:string):string;
}

export const ValidacionExpatriadosDetalleComponent = (props:Props) =>{
    
    const {filter,visible,translate} = props;

	const api:any = new ValidacionesExpatriadosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
    let [data, setData] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let result: any;

	useEffect(()=>{
		setData([])
	},[filter])

    const GetValidaciones = async(dataFilter:any)=>{
		setIsLoading(true)
		try {
			result = await api.ListarValidacionesExpatriados(dataFilter);
			if(result.data!==null && result.data!=="")
			{
				setData([...result.data])
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
    }

	const Validar = async(dataValidation:any)=>{
		setIsLoading(true)
		try {
			result = await api.ValidarExpatriados(dataValidation);
			if(result.data === true)
			{
				launchNotification({type:"success",title:translate('validaciones-expatriados'),message:`${translate('msg-notificacion-realizar-validaciones')}.`})
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	}

    return <ValidacionExpatriadosDetalleScreen data={data} visible={visible} isLoading={isLoading} 
	handleFilter={GetValidaciones} selection={filter} handleValidar={Validar} translate={translate}/>
}